import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Route, Router } from '@angular/router';
import { UnityRouteUrlTrees } from '@unity/utils/types';
import { RouteService } from './route.service';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private readonly router = inject(Router);
  private readonly routeService = inject(RouteService);

  private isAuthorizedRoute(matchingRoute: Route) {
    // If this is a virtual route, check default child instead
    const routeToCheck = matchingRoute.component ? matchingRoute : matchingRoute.children?.find(r => r.path === '');
    if (!routeToCheck) {
      return false;
    }

    return !!routeToCheck.component;
  }

  public navigateUp() {
    const startingRoute = this.routeService.getActiveRoute();
    let nextRouteUp: ActivatedRoute | null | undefined = startingRoute.parent;
    if (startingRoute.snapshot.url.length === 0) {
      // Skip one if we started on a default child
      nextRouteUp = nextRouteUp?.parent;
    }

    while (nextRouteUp) {
      if (!nextRouteUp.routeConfig) {
        // We found an unconfigured route; stop traversal
        break;
      }
      if (this.isAuthorizedRoute(nextRouteUp.routeConfig)) {
        return this.router.navigate(['.'], { relativeTo: nextRouteUp });
      }
      nextRouteUp = nextRouteUp.parent;
    }

    // No intermediate landing, go home
    return this.router.navigate(['/']);
  }

  public navigate(url: UnityRouteUrlTrees, extras?: NavigationExtras) {
    return this.router.navigate(url, extras);
  }

  // Show the 'not found' page without landing on a real route
  public notFound() {
    return this.router.navigate(['/not-found'], { skipLocationChange: true });
  }
}
